import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Button,
  ScalableImage,
  Typography,
} from "design_system/src";

import { ReactComponent as Cool } from "design_system/src/static/icons/emoji-cool.svg";
import { ReactComponent as Fire } from "design_system/src/static/icons/fire.svg";
import { ReactComponent as Energy } from "design_system/src/static/icons/energy.svg";

import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { getSpanishColorName } from "helpers/translateColorValues";
import { formatPrice } from "helpers/formatPrice";
import { prices } from "helpers/prices";
import { Link } from "react-router-dom";
import styles from "./VehicleItem.module.scss";


/* eslint-disable no-shadow */
enum LabelEnum {
  maintenanceDays = "maintenanceDays",
  discount = "discount",
  new = "new",
  none = "none",
}

interface LabelProps {
  name: string;
  icon: any;
  color: "secondary_500" | "red_300" | "primary_300" | "neutral_100";
}

const LABELS: {[key: string]: LabelProps} = {
  [LabelEnum.maintenanceDays]: {
    name: "Entrega inmediata",
    icon: Cool,
    color: "secondary_500",
  },
  [LabelEnum.discount]: {
    name: "Descuento",
    icon: Fire,
    color: "red_300",
  },
  [LabelEnum.new]: {
    name: "Moto nueva",
    icon: Energy,
    color: "primary_300",
  },
  [LabelEnum.none]: {
    name: "",
    icon: Energy,
    color: "neutral_100",
  },
};

interface RecommendedVehicleItemProps {
  vehicle: TVehicle;
}


const RecommendedVehicleItem: React.FC<RecommendedVehicleItemProps> = ({ vehicle }) => {
  const getLabelInfo = (vehicle: TVehicle): LabelProps => {
    if (vehicle.isNewVehicle) return LABELS[LabelEnum.new];

    if (vehicle.hasDiscount()) return LABELS[LabelEnum.discount];

    if (vehicle.maintenanceDays === 0) return LABELS[LabelEnum.maintenanceDays];

    return LABELS[LabelEnum.none];
  };

  const { name, color, icon: Icon}: LabelProps = getLabelInfo(vehicle);

  return (
    <div className={styles.VehicleItem}>
      <div className="display_flex flex_align_center m_b_sm">
        <Typography weight="600" scale="medium" className={`text_${color}`}>{name}</Typography>
        <Icon className={`w_md h_md m_l_sm text_${color}`} />
      </div>

      <div className="h_150_px m_b_sm">
        <ScalableImage
          className="img_cover br_md"
          src={vehicle.images[0]?.url}
          alt={`Moto ${vehicle.brand.name} ${vehicle.model.name}, ${vehicle.isNewVehicle ? "nueva" : "seminueva"} de ${vehicle.cylindersCapacity}cc, año ${vehicle.year}, color ${getSpanishColorName(vehicle.color ?? "black").toLocaleLowerCase()} en venta en ${vehicle.location.city.name}`}
          desktopWidth={20}
          mobileWidth={50}
        />
      </div>

      <Typography weight="600" scale="small">Precio</Typography>
      <Typography weight="600" scale="small">${formatPrice(prices(vehicle.marketPrice), "")}</Typography>
      <Typography weight="400" scale="xxsmall" className="m_y_xs">{vehicle.brand.name} {vehicle.model.name} {vehicle.cylindersCapacity}</Typography>

      <div className="w_100_per display_flex">
        <Link to={`/catalogo/${vehicle.internalId}`} className="w_100_per display_flex text_decoration_none">
          <Button scale="small" variant="outline" className="w_100_per br_md">
            Quiero esta moto
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default RecommendedVehicleItem;